import React, { Component } from "react";
import Dialog from "./dialog";
import Tooltip from "../../components/bases/tooltips/tooltip";
import { apiSetNewTimeCodeAsset, apiSearchAssetsFromProject, apiReadOneAsset } from "../../utils/apis";
import "./applyoffsetvideo.css"
import { UploadComponentRef, GlobalContext } from "../../utils/globalprovider";
import imgVideo from "./assets/offsetvideo/video.png"
import imgTranscript from "./assets/offsetvideo/transcript.png"
import imgTranscriptC from "./assets/offsetvideo/transcriptc.png"
import imgST from "./assets/offsetvideo/st.png"
import imgSTC from "./assets/offsetvideo/stc.png"
import imgAD from "./assets/offsetvideo/ad.png"
import imgSequences from "./assets/offsetvideo/seq.png"
import imgDocuments from "./assets/offsetvideo/doc.png"
import Icon from "../../components/bases/icone/icon";
import { V2_ConvertTimeCodeStringToSecond, V2_recfps } from "../../utils/timecodev2";


class ApplyOffsetVideoLine extends Component


{

  static contextType = GlobalContext;


  constructor(props)
  {
    super(props)
  }
  render()
  {

    var image = imgVideo;
    var color = "#FFFFFF";
    var tooltip = {fr:"Vidéo", en:"Video"};
    switch (this.props.asset.astype)
    {
      case 1: 
        tooltip = {fr:"Transcription originale", en:"Original transcription"}
        image = imgTranscript; break;
      case 2: 
        tooltip = {fr:"Transcription corrigée", en:"Corrected transcription"}
        image = imgTranscriptC; break;
      case 3:
        color = "#A0A0A0"; break;
      case 4: 
        tooltip = {fr:"Sous titres calculés", en:"Generate subtitles"}
        image = imgST; break;
      case 5: 
        tooltip = {fr:"Sous titres corrigés", en:"Corrected subtitles"}
        image = imgSTC; break;
      case 6: 
        tooltip = {fr:"Transcription de sous-titres corrigés", en:"Transcription from corrected subtitles"}
        image = imgTranscript; break;
      case 7: 
        tooltip = {fr:"Audio description", en:"Audio description"}
        image = imgAD; break;
      case 8: // sequences
        tooltip = {fr:"Séquences", en:"Sequences"}
        image = imgSequences; break;
      case 9: // documents
        tooltip = {fr:"Documents", en:"Documents"}
        image = imgDocuments; break;
        
    }

    var extendclass="";
    if (this.props.asset.state === 1)
      extendclass = " applyOffsetTdProcessing";
    if (this.props.asset.state === 2)
      extendclass = " applyOffsetTdDone";

    
    return(
        <tr className="applyOffsetTrAssetLine">
          <td className={"applyOffsetTdAssetLine" + extendclass} style={{color:color}}>
            {this.props.asset.asid}
          </td>
          <td className={"applyOffsetTdAssetLine" + extendclass} style={{paddingTop:"3px",color:color}}>
              <Tooltip text={this.context.language=="fr"?tooltip.fr:tooltip.en}>
              <Icon
                image={image}
                height={16} width={16}/>
              </Tooltip>
          </td>
          <td className={"applyOffsetTdAssetLine" + extendclass} style={{color:"#A0A0A0",textAlign:"left"}}>
            {this.props.asset.astitle}
          </td>
          <td className={"applyOffsetTdAssetLine" + extendclass} style={{color:color}}>
            {this.props.asset.astimecode}
          </td>

          <td className="applyOffsetTdAssetLine">
            <input type="checkbox" onClick={e=>{this.props.onclick(this.props.index)}}
              checked={this.props.asset.applyable & this.props.asset.apply} 
              disabled = { this.props.disable }
            />
          </td>

        </tr>)
    }
  
  }

class ApplyOffsetVideo extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        fr:"Appliquer l'offset de la vidéo aux assets", 
        en:"Apply the Video Offset to the Assets",
      };
    this.state.title = title;
    this.state.tobecenter = true;

    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      {type:"back", disabled:false},
      {type:"ok", disabled:false},
      
    ]



    this.state.assets = [];
    console.log("datas ", this.props.datas);
    this.state.processing = false;



    this.onAssetsDownloaded = this.onAssetsDownloaded.bind(this);
    this.handleButton =  this.handleButton.bind(this);
    this.onApplyAsset = this.onApplyAsset.bind(this);
    this.callbackReadOneAsset = this.callbackReadOneAsset.bind(this);
    this.endProcessAsset = this.endProcessAsset.bind(this)

    this.onQuit = this.onQuit.bind(this);
    this.onValid = this.onValid.bind(this);
    this.gereNext = this.gereNext.bind(this);
    this.didMount = false;

   
    
  }
onAssetsDownloaded(datas)
  {



    datas.forEach(element => {
      element.state = 0; // 0 nothing, 1 processing 2 done
      if ((element.astype !== 3) &&  (element.astype !== 9))
      {
        element.applyable = true;
        element.apply=true;
      }
      else
        element.applyable = false;
    });

    this.setState({assets:datas});
  }


  componentDidMount()
  {

    // lecture de la vidéo

    this.didMount=true;
    super.componentDidMount();
    apiSearchAssetsFromProject({pjid: this.props.pjid}, this.onAssetsDownloaded);

  }


  onValid(datas)
  {
  }

  onQuit()
  {
    if (this.state.processing) return;
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    
    if (buttonkey === "ok")
    {

        var buttons = 
        [
          //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
          {type:"back", disabled:true},
          {type:"ok", disabled:true},
          
        ]

        this.setState({buttons:buttons, processing: true});

        this.gereNext()
        //this.props.onButton(buttonkey);
        return;
    }

    else

      this.props.onButton(buttonkey);
  }

  onApplyAsset(index)
  {
    var assets = this.state.assets;
    assets[index].apply = !assets[index].apply;
    this.setState({assets:assets});
  }
  render()
  {


    var liste = [];

    this.state.assets.forEach((element,index) => {


      liste.push(
        <ApplyOffsetVideoLine
          index = {index}
          onclick = {this.onApplyAsset}

          disable = {this.state.processing || !element.applyable}
          asset = {element}/>
      )
    });


    return super.render(
  
    <>
      <div style = {{width:600, height: 420}}>
              
            <div className = "applyOffsetHeader">
              <span className="applyOffsetLabel">
                {this.context.language=="fr"?"Offset à appliquer ":"Offset to Apply"}
              </span>
              <span className="applyOffsetText">
                {this.props.datas.reeloffset}
              </span>
            </div>

            <div className = "applyOffsetBody">
              <table>
              <tr className="applyOffsetTrAssetTitle">
                <td style={{width:"20px", textAlign:"center"}}className="applyOffsetTdAssetTitle">
                  ID
                </td>
                <td style={{width:"40px", textAlign:"center"}}className="applyOffsetTdAssetTitle">
                  Type
                </td>
                <td style={{width:"300px"}}className="applyOffsetTdAssetTitle">
                  {this.context.language=="fr"?"Titre":"Title"}
                </td>
                <td style={{width:"100px", textAlign:"center"}}className="applyOffsetTdAssetTitle">
                  Offset
                </td>
                <td style={{width:"100px", textAlign:"center"}}className="applyOffsetTdAssetTitle">
                  {this.context.language=="fr"?"Appliquer":"Apply"}
                </td>

              </tr>
              {liste}
              </table>
            </div>
      </div>
     </>
    );
  }



  getCurrentDate = () => {
      const today = new Date();
    
      const year = today.getFullYear(); // Année AAAA
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (01-12)
      const day = String(today.getDate()).padStart(2, '0'); // Jour (01-31)
    
      return `${year}/${month}/${day}`;
    };


  /// **************************************************
  convertTranscription(datas,timecodedatas)
  {
    
    var transcription =  [];
    var newjson = JSON.parse(datas.asdatas);
    if ("transcription" in newjson)
        transcription = newjson.transcription;
    else
    {
        transcription = newjson;
        newjson = {};
    
    
    }

    console.log("convert", datas, transcription)
    newjson.num = timecodedatas.num;
    newjson.den = timecodedatas.den;
    newjson.framerate = timecodedatas.framerate;
    newjson.dropframe = timecodedatas.dropframe;
    newjson.timecode = timecodedatas.timecode;


    const lastoffset = V2_ConvertTimeCodeStringToSecond(
      datas.astimecode, datas.asnum, datas.asden,
      datas.asdropframe,"00:00:00:00");

    const newoffset = V2_ConvertTimeCodeStringToSecond(
      timecodedatas.timecode, 
      timecodedatas.num, 
      timecodedatas.den,
      timecodedatas.dropframe,"00:00:00:00");

    console.log("last ", lastoffset,"new ", newoffset);

    transcription.forEach(word =>{
      var tcin = word.startTime;
      var tcout = word.endTime;

      word.startTime = tcin - lastoffset + newoffset;
      word.endTime = tcout - lastoffset + newoffset;
   })

    newjson.transcription = transcription;
    console.log("retour ", newjson)
    return newjson;


  }

  convertSequences(datas,timecodedatas)
  {
    var newjson = JSON.parse(datas.asdatas);
    var sequences = newjson.sequences;
    const lastoffset = V2_ConvertTimeCodeStringToSecond(
      datas.astimecode, datas.asnum, datas.asden,
      datas.asdropframe,"00:00:00:00");

    const newoffset = V2_ConvertTimeCodeStringToSecond(
      timecodedatas.timecode, 
      timecodedatas.num, 
      timecodedatas.den,
      timecodedatas.dropframe,"00:00:00:00");

    console.log("last ", lastoffset,"new ", newoffset);

    sequences.forEach(sequence =>{
      var tcin = sequence.in;
      var tcout = sequence.out;

      sequence.in = tcin - lastoffset + newoffset;
      sequence.out = tcout - lastoffset + newoffset;

    })

    newjson.sequences = sequences;
    console.log("retour ", newjson)
    return newjson;
  }


  convertSubtitles(datas,timecodedatas)
  {
    
    var newjson = JSON.parse(datas.asdatas);
    var subtitles = newjson.subtitles;

    console.log("convert", datas, subtitles)
    newjson.num = timecodedatas.num;
    newjson.den = timecodedatas.den;
    newjson.framerate = timecodedatas.framerate;
    newjson.dropframe = timecodedatas.dropframe;
    newjson.timecode = timecodedatas.timecode;


    const lastoffset = V2_ConvertTimeCodeStringToSecond(
      datas.astimecode, datas.asnum, datas.asden,
      datas.asdropframe,"00:00:00:00");

    const newoffset = V2_ConvertTimeCodeStringToSecond(
      timecodedatas.timecode, 
      timecodedatas.num, 
      timecodedatas.den,
      timecodedatas.dropframe,"00:00:00:00");

    console.log("last ", lastoffset,"new ", newoffset);

    subtitles.forEach(subtitle =>{
      var tcin = subtitle.in;
      var tcout = subtitle.out;

      subtitle.in = tcin - lastoffset + newoffset;
      subtitle.out = tcout - lastoffset + newoffset;

      if ("lines" in subtitle)
      {
          subtitle.lines.forEach(line =>{

              if ("words" in line)
              {
                line.words.forEach (word =>{
                  var tcin = word.in;
                  var tcout = word.out;

                  word.in = tcin - lastoffset + newoffset;
                  word.out = tcout - lastoffset + newoffset;

                })
              }
          })
    }
   })

    newjson.subtitles = subtitles;
    console.log("retour ", newjson)
    return newjson;
  }

  callbackReadOneAsset(datas)
  {
    console.log(datas)


    var timecodedatas = {
      id: datas.asid,
      timecode: this.props.datas.timecode,
      num: this.props.datas.num,
      den: this.props.datas.den,
      framerate: V2_recfps(this.props.datas.num, this.props.datas.den),
      dropframe: this.props.datas.dropframe,
    }

    console.log("set new time code ", timecodedatas)


    var newjson = null;
    switch (datas.astype)
    {
      case 1:
      case 2:
          newjson = this.convertTranscription(datas,timecodedatas);
          break;
      case 4:
      case 5:
          newjson = this.convertSubtitles(datas,timecodedatas);
          break;
      case 6:
          newjson = this.convertTranscription(datas,timecodedatas);
          break;
      case 8:
          newjson = this.convertSequences(datas,timecodedatas);
          break;
      default:
        this.endProcessAsset();          
        return;
    }

    // ici il faut écrire l'asset et upload json

    const sjson = JSON.stringify(newjson);

    const memoryFile = new File([sjson], datas.asfile + "." +datas. asext, 
          {
          type: "application/json", // MIME type for JSON
          lastModified: new Date().getTime() // Timestamp for the file
          });            
    

    if ((UploadComponentRef) && (UploadComponentRef.current))
    {
      const formulaire = {
        asid: datas.asid,
        aspjid: this.props.pjid,
        astype: datas.astype,
        uploadfile: memoryFile,
        filenamedest: datas.asfile + "." +datas.asext,
        filenamesource: datas.asfile,
        asupdatedate: this.getCurrentDate(),
      }
      console.log("upload formulaire", formulaire)
      UploadComponentRef.current.addUpload(this.props.pjid, formulaire, 2 ,this.onSaveDone);
      
    }


    apiSetNewTimeCodeAsset(timecodedatas,this.endProcessAsset);


  }

  endProcessAsset()
  {
    var assets = this.state.assets;
    assets[this.state.current].state = 2; // Done
    this.setState({assets:assets});
    this.gereNext();

  }

  gereNext()
  {
    // recherche de l'élément suivant à traiter
    
    const index = this.state.assets.findIndex(
      asset => (asset.apply && (asset.state !== 2))
    )

    

    if (index === -1) // finish
    {
      this.props.onButton("ok");
    }
    else
    {
       console.log("on va traiter l'index ", index);
       var assets = this.state.assets;
       assets[index].state = 1; // processing
       assets[index].processing = true;
       this.setState({assets: assets, current:index});
      var datas = {asid: assets[index].asid};
      apiReadOneAsset (datas, this.callbackReadOneAsset);          

    }

  }


}



export default ApplyOffsetVideo;